import {
  consolidationScheduleIdFormat,
  returnsCenterIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { ConsolidationScheduleRecurrenceSchema } from "./consolidation-schedule-fields";

export const createConsolidationSchedule = {
  name: "createConsolidationSchedule" as const,
  input: z.object({
    isDefault: z.boolean(),
    name: z.string().trim().min(1),
    recurrence: ConsolidationScheduleRecurrenceSchema,
    returnsCenterId: returnsCenterIdFormat.schema,
    startsAt: z.date(),
    timezone: z.string().trim().min(1),
  }),
  output: z.object({ id: consolidationScheduleIdFormat.schema }),
};
